import React from 'react'
import ReactDOM from 'react-dom'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'
import getMuiTheme from 'material-ui/styles/getMuiTheme'
import registerServiceWorker, { unregisterServiceWorker } from './registerServiceWorker'
import App from './components/App'
import './style.css'
import theme from './theme'
import './assets/fonts/proxima-nova/fonts.min.css'
// import 'default-passive-events'

// injectTapEventPlugin()

const muiTheme = getMuiTheme(theme)

class ThemedApp extends React.Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <App />
      </MuiThemeProvider>
    )
  }
}

ReactDOM.render(<ThemedApp />, document.getElementById('root'))

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js